// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"9b10c3f8","480":"cbb848da","611":"4a601c38","787":"c755a7d1","960":"60c067c8","970":"d61efe50"}[chunkId] + ".chunk.js";
};